import React,{useContext,useState} from "react";
import {Button} from "@material-ui/core";
import {AuthContext} from "../../context/Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";
export default function AdminTakeoverButton({ticket,onTaken}){
 const {user}=useContext(AuthContext);const [busy,setBusy]=useState(false);
 if(user?.profile!=="admin"||ticket?.status!=="open"||!ticket.userId||Number(ticket.userId)===Number(user.id))return null;
 async function assume(){setBusy(true);try{const {data}=await api.post(`/tickets/${ticket.id}/assume`,{expectedOwnerId:Number(ticket.userId)});if(onTaken)onTaken(data);}catch(error){toastError(error);}finally{setBusy(false);}}
 return <Button color="primary" variant="contained" size="small" disabled={busy} onClick={assume}>{busy?"Assumindo…":"Assumir atendimento"}</Button>;
}
